import { defineStore } from 'pinia';
import ajax from '@/utils/Ajax';

export const useRegisterStore = defineStore('register', {
  state: () => ({
    //1.step如果進頁面有socialToken.google，social match成功走2，沒有走1-2
    //2.step如果進頁面有socialToken.tk或ig，social match成功走2(matchNum要歸零)，沒有的話matchNum+1，走1-2(matchNum到2的話畫面會提示)
    loading: false,
    step: '1', //step一開始為1-1 //1-1,1-2,2-1,2-2,2-3,2-4,3
    inviteBrand: null, //紀錄邀請的brand，在termslist第一個顯示邀請的brand
    registerData: {
      //紀錄註冊的各種資料
      email: '',
      user_status: 0,
      avatar: null,
      name: '',
    },
    //handle要存 localStorage,避免回來其他hanlde資訊遺失
    socialList: JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_socialList')) || null,
    matchSocial: false, //針對email沒有match才需要使用的match social，沒有match不允許繼續註冊
    matchNum: Number(window.localStorage.getItem('CREATOR_PROTAL_match_count')) || 0, //只允許match 2次，match 2次要讓使用者重整才可再使用
    socialToken: {
      //連接出去的時候會產key存在這裡，頁免返回要根據有的key去做事，但有key做完事就要移除key(就算做失敗也要移除)
      google: JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_google_social_key')) || null,
      tk: JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_tk_social_key')) || null,
      ig: JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_ig_social_key')) || null,
      yt: JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_yt_social_key')) || null,
    },
    goSocialStep: false, //如果email submit按過後，email驗證沒過，開啟的下一步去驗證social"提示"(這時候都還是step1)
    isGoogleRegister: false, //google註冊的
    verifityList: [
      {
        icon: 'instagram',
        name: 'Instagram',
        tag: 'ig',
        default_handle: '',
        backName: ['instagram', 'instagram_business','facebook_business'],
        show:true,
        social_platform: 'instagram',
      },
      {
        icon: 'tiktok-pure',
        name: 'TikTok',
        default_handle: '',
        tag: 'tk',
        backName: ['tikTok', 'tiktok_business'],
        show:true,
        social_platform: 'tikTok',
      },
      {
        icon: 'youTube',
        name: 'YouTube',
        default_handle: '',
        tag: 'yt',
        backName: ['youTube', 'youtube', 'youtube_business'],
        show: true,
        social_platform: 'youtube',
      },
    ], //紀錄需驗證social
    spHandle:[], 
  }),

  getters: {
    // Define your getters here
    // https://pinia.vuejs.org/core-concepts/getters.html
  },

  actions: {
    async matchEmail(res, tag) {
      //user_status=30 ⇒ email not match
      //user_status=40 ⇒ email match, need to update display_name & password
      //user_status=100 ⇒ had email
      console.log('matchEMAIL:res.user_status', res.user_status);
      switch (res.user_status) {
        case 30:
          this.step = '1-2';
          //email沒有match,所以走social match,數值都轉原始
          this.cleanUserHandle();
          window.localStorage.removeItem(`CREATOR_PROTAL_socialList`);
          break;
        case 40:
          this.step = '2-1';
          if (tag === 'google') {
            this.isGoogleRegister = true;
          }
          break;
        case 50:
          await this.handleVerSocialPage();
          break;
        case 60:
          this.spGetUserHandle();
          this.step = '2-4';
          break;
        case 90:
          this.step = '3';
          break;
        case 100:
          this.step = '2-2';
          //後端告訴前端已經有註冊(並且拿到token)，這時候要強制清除token，避免沒登錄動作就直接被轉進畫面
          window.localStorage.removeItem('token');
          window.localStorage.removeItem('CREATOR_PROTAL_Registor_Google');
          break;
      }
    },
    cleanUserHandle() {
      this.socialList = [
        { icon: 'instagram', name: 'Instagram', handle: '', tag: 'ig', matched: false },
        { icon: 'tiktok-pure', name: 'TikTok', handle: '', tag: 'tk', matched: false },
      ];
    },
    getUserHandle(tag, handle, matched) {
      if (!this.socialList) {
        this.cleanUserHandle();
      }

      const target = this.socialList.find((e) => e.tag === tag);
      if (target) {
        target.handle = handle;
        target.matched = matched;
      }
      window.localStorage.setItem('CREATOR_PROTAL_socialList', JSON.stringify(this.socialList));
    },
    clearUserHandle(tag) {
      switch (tag) {
        case 'google':
          this.socialToken.google = null;
          break;
        case 'tk':
          this.socialToken.tk = null;
          break;
        case 'ig':
          this.socialToken.ig = null;
          break;
      }
      window.localStorage.removeItem(`CREATOR_PROTAL_${tag}_social_key`);
    },
    //只有restart可以重製match，或是當match2滿足再次重新整理畫面的時候(觸發getKeyFineWhere)
    setMatchCount(num) {
      if (num) {
        this.matchNum = Number(this.matchNum) + 1;
        window.localStorage.setItem('CREATOR_PROTAL_match_count', this.matchNum);
      } else {
        this.matchNum = 0;
        window.localStorage.removeItem(`CREATOR_PROTAL_match_count`);
      }
    },

    async spGetUserHandle() {
      this.loading = true;
    
      try {
        const res = await ajax.get('/get-user-handle-list');
        const data = res.data.data;

        data.sort((a, b) => {
          const aHasIG = a.social_platform.includes('instagram') ? 1 : 0;
          const bHasIG = b.social_platform.includes('instagram') ? 1 : 0;
          return bHasIG - aHasIG; // 有 'ig' 的往前排
        });

        this.spHandle = data;

      } catch (err) {
        console.error('Error fetching user handle list:', err);
      } finally {
        this.loading = false;
      }
    },

    async handleRegisterUpdatePassword(type) {
      if(type.user_status===50){
        await this.handleVerSocialPage();
        await this.handleRegisterSocial();
        this.step = '2-3';
      }else{
        this.spGetUserHandle();
        this.step = '2-4';
      }
      
    },
    async handleRegisterSocial() {
      this.loading = true;
      try {
        const res = await ajax.get('/get-user-default-handle');
        const data = res.data.data;
        this.verifityList.forEach((platform) => {
          for (const key of platform.backName) {
            if (data[key] && data[key].handle) {
              platform.default_handle = data[key].handle;
              platform.connect_status=  data[key].connect_status;
              platform.handle = data[key].handle;
              break; // 找到就停止，不再繼續檢查 backName 中其他名稱
            }
          }
        });
      } catch (err) {
        console.error('Error fetching user handle list:', err);
      } finally {
        this.loading = false;
      }
    },

    async handleVerSocialPage() {
      await this.spGetUserHandle();
      if(this.spHandle.length > 0) {
        this.step = '2-4';
        return;
      }else{
        await this.handleRegisterSocial();
        this.step = '2-3';
       
      }
    }
  },
});
